import React, { FC } from 'react';
import { Comment } from 'api/conversations/types';
import { NewMessagesMarker } from './new-messages-marker';

interface Props {
  currentComment: Comment;
  lastReadCommentId?: number;
}

export const MessageFooter: FC<Props> = ({
  currentComment,
  lastReadCommentId,
}) => {
  return (
    <>
      {lastReadCommentId === currentComment.commentId ? (
        <NewMessagesMarker />
      ) : null}
    </>
  );
};
